import * as swcHelpers from '@swc/helpers';
import { getLocalizedString } from '@grandvisionhq/utils';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import { getAttribute } from '../../../utils/get-line-item-attribute.js';
import { getLineItemAvailability } from '../../../utils/get-line-item-availability.js';
import { getLineItemImageUrl } from '../../../utils/get-line-item-image-url.js';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/graphql';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/subscription/subscription-details.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import { toBaseLineItem } from './base-line-item.js';
import { isContactLensBundleTypeDetails } from './utils/cart-line-item-product-type-guards.js';

const isBundledSolutionLineItem = (bundledLineItem)=>{
    return bundledLineItem.type === 'SOLUTION';
};
const toContactLensesBundleCartLineItem = (cartLineItem, intl, settings)=>{
    var ref, ref1, ref2;
    const base = toBaseLineItem(cartLineItem, settings, intl);
    const mainBundleLineItem = cartLineItem.bundleLineItems.find((bundleLineItem)=>bundleLineItem.isMainBundleLineItem
    );
    const bundledSolutionLineItem = (ref = cartLineItem.bundleLineItems) === null || ref === void 0 ? void 0 : ref.find(isBundledSolutionLineItem);
    const typeDetails = cartLineItem.typeDetails && isContactLensBundleTypeDetails(cartLineItem.typeDetails) && cartLineItem.typeDetails;
    const prescription = !typeDetails ? undefined : {
        leftEye: Object.fromEntries(Object.entries(typeDetails.prescription.leftLens).map(([key, value])=>[
                key,
                value ? value.toString() : null, 
            ]
        )),
        rightEye: Object.fromEntries(Object.entries(typeDetails.prescription.rightLens).map(([key, value])=>[
                key,
                value ? value.toString() : null, 
            ]
        ))
    };
    const imageUrl = (mainBundleLineItem === null || mainBundleLineItem === void 0 ? void 0 : mainBundleLineItem.legacyProduct.masterData.current.variant) ? getLineItemImageUrl(mainBundleLineItem === null || mainBundleLineItem === void 0 ? void 0 : mainBundleLineItem.legacyProduct.masterData.current.variant) : '';
    const availability = mainBundleLineItem === null || mainBundleLineItem === void 0 ? void 0 : mainBundleLineItem.legacyProduct.masterData.current.variant.availability;
    return swcHelpers.objectSpread({}, base, {
        type: 'CONTACT_LENS_BUNDLE',
        productType: 'contact-lenses-bundle-benelux'
    }, availability ? {
        availability: getLineItemAvailability(availability)
    } : {}, {
        imageUrl,
        title: getLocalizedString(mainBundleLineItem === null || mainBundleLineItem === void 0 ? void 0 : mainBundleLineItem.legacyProduct.masterData.current.name, intl.locale),
        subtitle: `${intl.getLabel('products.monthlySubscription')} ${mainBundleLineItem ? getAttribute(mainBundleLineItem === null || mainBundleLineItem === void 0 ? void 0 : mainBundleLineItem.legacyProduct.masterData.current.variant, 'lensType') : ''}`,
        altText: getLocalizedString(mainBundleLineItem === null || mainBundleLineItem === void 0 ? void 0 : mainBundleLineItem.legacyProduct.masterData.current.name, intl.locale),
        prescription,
        bundleChildLineItems: bundledSolutionLineItem ? [
            {
                title: intl.getLabel('facets.productType.solutions'),
                body: getLocalizedString(bundledSolutionLineItem.legacyProduct.masterData.current.name, intl.locale),
                price: ((ref1 = bundledSolutionLineItem.price) === null || ref1 === void 0 ? void 0 : ref1.total.gross) || 0,
                originalPrice: ((ref2 = bundledSolutionLineItem.price) === null || ref2 === void 0 ? void 0 : ref2.total.subtotal) || 0
            }, 
        ] : undefined
    });
};

export { toContactLensesBundleCartLineItem };
//# sourceMappingURL=contact-lenses-bundle-line-item.js.map
